import {getColumnCacheName, initColumnParams} from '../../util/componentUtil';

export default {
  props: {
    tabConfig: {
      type: Object,
      default() {
        /*
          {
            delay: 0 // tab切换后触发查询的延时，如果不传，默认是0
            field: '' // queryParams的key
            activeName: '' // 默认选中标签,这个属性会传到查询接口中
            list: [
              {
                label: '' // 标签的title
                name: '' // 标签的标识
              }
            ]
          }
          */
        return null;
      }
    },
    id: String,
    columnCache: String,
    columns: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * 是否显示底部统计行
     */
    showFooter: {
      type: Boolean,
      default: false
    },
    /**
     * 统计行的显示方法
     */
    footerMethod: Function,
  },
  data() {
    return {
      slotArray: [],
      realColumnCache: ''
    };
  },
  computed: {
    realId() {
      if (this.id) {
        return this.id;
      }
      return this.realColumnCache;
    },
    hasDataAttribute () {
      return Object.prototype.hasOwnProperty.call(this.$attrs, 'data');
    },
    realFooterMethod() {
      return this.footerMethod ? this.footerMethod : this.$footerMethod;
    }
  },
  methods: {
    $footerMethod({columns}) {
      // 普通分页
      const arr = [];
      for (let i = 0; i < columns.length; i++) {
        const column = columns[i];
        const field = column.field;
        if (i === 0) {
          arr.push('总计');
          continue;
        }
        if (this.summary && Object.prototype.hasOwnProperty.call(this.summary, field)) {
          arr.push(this.summary[field]);
        } else {
          arr.push(null);
        }
      }
      return [arr];
    },
    setSummary(summary) {
      this.summary = summary;
    },
    handleResize() {
      const xTable = this.getXTable();
      if (xTable) {
        const grid = xTable.getGridInstance();
        grid.updateCellAreas();
        grid.recalculate(true);
      }
    },
    getSlotArray () {
      return this.slotArray;
    },
    getCheckboxRecords() {
      return this.getXTable().getCheckboxRecords();
    },
    getRadioRecord() {
      return this.getXTable().getRadioRecord();
    },
    getColumns() {
      return this.getXTable().getColumns();
    },
    loadColumn(columns) {
      return this.getXTable().loadColumn(columns);
    },
    getTableData() {
      return this.getXTable().getTableData();
    },
    getGridInstance() {
      return this.getXTable().getGridInstance();
    },
    getXTable() {
      return this.$refs.xTable;
    },
    loadData(data) {
      this.getXTable().loadData(data);
    },
    /**
     * 初始化表格拖拽
     * @return {Promise<unknown>}
     */
    initTableSetting() {
      let resolveFn;
      const promise = new Promise((resolve) => {
        resolveFn = resolve;
      });
      setTimeout(() => {
        this.getXTable().initTableSetting().then(() => {
          resolveFn();
        });
      });
      return promise;
    }
  },
  watch: {
    columnCache: {
      handler() {
        // 因为this.$route会随着页面跳转而改变，realColumnCache不能做成计算属性
        this.realColumnCache = this.columnCache ? this.columnCache : getColumnCacheName({name: this.$route.path});
      },
      immediate: true
    },
    columns: {
      handler() {
        initColumnParams({columns: this.columns});
        if (this.autoInitTableSetting) {
          this.initTableSetting();
        }
      },
      immediate: true
    }
  },
  mounted() {
    const xTable = this.$refs.xTable;
    this.slotArray = xTable.slotArray;
    xTable.getGridInstance().connect(this.$refs.vxeToolbar);
  }
};
